import { useEffect, useState } from 'preact/hooks'
import { SearchspringRecommendProvider } from '../fetchers/recommend'
import { CarouselResults } from './CarouselResults'
import clsx from 'clsx'
import { BeaconAnalyticsProvider } from '../hooks/useBeaconAnalytics'
import { dataTracker } from '@/components/snippets/analytics/analytics'

export function CarouselTabbed({ values, itemClass, productId, idList }) {
  const ids = idList.split(',')
  const profiles = values.split(',').map((value, i) => {
    const [profile, label] = value.split(':')
    const id = ids[i]
    return {
      profile,
      label,
      id
    }
  })

  const [activeProfile, setActiveProfile] = useState(profiles[0])
  const [loadedProfiles, setLoadedProfiles] = useState(new Set([profiles[0].profile]))

  useEffect(() => {
    const analyticsProfile = dataTracker.getSectionDataById(activeProfile.id)
    if (analyticsProfile) {
      dataTracker.replaceSectionDataById(activeProfile.id, analyticsProfile)
    }
  }, [activeProfile])

  const handleProfileChange = (item) => {
    setLoadedProfiles(prev => new Set([...prev, item.profile]))
    setActiveProfile(item)
  }

  return (
    <div className="flex flex-col gap-6 md:gap-8">
      <div className="relative z-10 flex gap-4 w-fit">
        {profiles.map((item) => (
          <button
            key={item.profile}
            className={clsx(
              'h4 border-b pb-1',
              item.profile === activeProfile?.profile
                ? 'border-primary-blue text-primary-blue'
                : 'border-transparent text-neutrals-secondary-grey'
            )}
            onClick={() => handleProfileChange(item)}
          >
            {item.label}
          </button>
        ))}
      </div>
      <div style="--translate-y-18:-4.5rem;" className="md:translate-y-[--translate-y-18]">
        {profiles.map((item) => (
          loadedProfiles.has(item.profile) && (
            <div
              key={item.profile}
              id={item.id}
              data-dl-section-id={item.profile}
              data-dl-section-name={item.label}
              className={clsx(
                'transition-opacity duration-300',
                item.profile !== activeProfile.profile ? 'opacity-0 h-0 overflow-hidden' : 'opacity-100'
              )}
            >
              <SearchspringRecommendProvider profile={item.profile} sku={productId}>
                <BeaconAnalyticsProvider profile={item.profile}>
                  <CarouselResults className={itemClass} hideControlsOnMobile={true} />
                </BeaconAnalyticsProvider>
              </SearchspringRecommendProvider>
            </div>
          )
        ))}
      </div>
    </div>
  )
}
